import Vue from 'vue'
import store from '@/store/index.js'
import axiosInstance from 'axios'
import { showError } from '@/utils/notification.js'

// API modules
import startup from '@/api/modules/startup.js'
import billHistory from '@/api/modules/billHistory.js'
import contactUs from '@/api/modules/contactUs.js'
import powerBIReport from '@/api/modules/powerBIReport.js'
import reports from '@/api/modules/reports.js'
import progressivePurchasing from '@/api/modules/progressivePurchasing.js'
import user from '@/api/modules/user.js'
import config from '@/api/modules/config.js'
import customGroup from '@/api/modules/customGroup.js'

export let axios = axiosInstance.create({
  baseURL: startup.resourceServer.messagesUrl,
})
console.log('Complete Axios setup with response from startup env', startup.resourceServer.messagesUrl)
axios.interceptors.request.use(
  config => {
    store.commit('loading', true)
    return config
  },
  error => {
    store.commit('loading', false)
    return Promise.reject(error)
  }
),
  axios.interceptors.response.use(
    response => {
      store.commit('loading', false)
      return response
    },
    error => {
      let errorMessage = 'Something went wrong, please try again.'
      if (error === undefined || error.response === undefined) {
        if (error && error.message) {
          console.log(error.message)
        }
        showError(errorMessage)
        //window.location.href = '/'
      } else {
        const { status } = error.response
        if (status === 401) {
          console.log(error.message)
          showError('This operation is not authorized.')
          setTimeout(() => {
            window.location.href = '/'
          }, 5000)
        } else if (status === 500) {
          console.log(error.message)
          showError(errorMessage)
        } else {
          console.log(error.message)
          showError(errorMessage)
        }
      }
      store.commit('loading', false)
      return Promise.reject(error)
    }
  )

//add okta token as part of all axios calls
export const addHeader = function (accessToken, timeOut = 5000, responseType = 'json') {
  return {
    responseType: responseType,
    //timeout: timeOut,
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  }
}

// insert into vue prototype, access via this.$api.user.getUserInfo()
Vue.prototype.$api = {
  billHistory,
  contactUs,
  powerBIReport,
  reports,
  progressivePurchasing,
  user,
  config,
  customGroup,
  startup,
}
